import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EDistinct,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTeamSlider = {
  factory: EElement({
    id: '08855bb5-21c6-5d0d-5f6e-1ef8855d3e03',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('7a6a4223-2b09-a005-afa0-dd855e67cea8')]),
      children: EList([
        EElement({
          id: '449ce788-6f39-b2c2-09fe-c4a7c054129b',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '07684848-96cd-1767-3e2b-03a921018d3d',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: '07684848-96cd-1767-3e2b-03a921018d3e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Team section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '157bc37c-990a-7962-6bad-4b52a207b495',
                type: qualify(
                  Plugins.name('Basic'),
                  Component.name('Paragraph')
                ),
                data: ERecord({
                  styleBlockIds: EList([
                    EText('e8e462ae-eca2-3d8e-55fa-0d15b916d1ba'),
                  ]),
                  children: EList([
                    EElement({
                      id: '157bc37c-990a-7962-6bad-4b52a207b496',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.'
                      ),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '521ef191-5e66-658e-6967-11c7bdbdab15',
                type: qualify(
                  Plugins.name('Slider'),
                  Component.name('SliderWrapper')
                ),
                data: ERecord({
                  slider: ERecord({
                    navSpacing: ENumber(12),
                    navShadow: EBoolean(false),
                    autoplay: EBoolean(false),
                    delay: ENumber(4000),
                    iconArrows: EBoolean(true),
                    animation: EEnum('slide'),
                    navNumbers: EBoolean(false),
                    easing: EEnum('ease'),
                    navRound: EBoolean(true),
                    hideArrows: EBoolean(false),
                    disableSwipe: EBoolean(false),
                    duration: ENumber(500),
                    infinite: EBoolean(true),
                    autoMax: ENumber(0),
                    navInvert: EBoolean(true),
                    type: EText('wrapper'),
                  }),
                  styleBlockIds: EList([
                    EText('9ed74efa-872c-7f3d-7ba4-cc728d8fed43'),
                  ]),
                  children: EList([
                    EElement({
                      id: '521ef191-5e66-658e-6967-11c7bdbdab16',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderMask')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('slides'),
                        }),
                        children: EList([
                          EElement({
                            id: '521ef191-5e66-658e-6967-11c7bdbdab17',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3aec51d9-cba5-938c-dbde-27f182400dc9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '1f2fb7a2-468a-71f9-fece-d271bc6a647d',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'a105299c-cb5a-5902-b72e-db275357231e',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '3536b74c-dbd1-dea3-859a-201ed4a7abe0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '3536b74c-dbd1-dea3-859a-201ed4a7abe1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'd60ca8d9-1a52-be5a-1ca5-c4eb3d37ae2f',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'd60ca8d9-1a52-be5a-1ca5-c4eb3d37ae30',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '0c03439a-2a7c-3c75-0c6d-8662ac772007',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0c03439a-2a7c-3c75-0c6d-8662ac772008',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: '0c03439a-2a7c-3c75-0c6d-8662ac772009',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '0c03439a-2a7c-3c75-0c6d-8662ac77200a',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '521ef191-5e66-658e-6967-11c7bdbdab18',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c6',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c8',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0c9',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0ca',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0cb',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'e76626a2-dbeb-d33a-2979-e6ca340bd0cc',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '19482082-f232-2394-97cd-f5203a636e30',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '82c611c3-52f5-5bef-2f32-528ff50e55bb',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '82c611c3-52f5-5bef-2f32-528ff50e55bc',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: '82c611c3-52f5-5bef-2f32-528ff50e55bd',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '82c611c3-52f5-5bef-2f32-528ff50e55be',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '82c611c3-52f5-5bef-2f32-528ff50e55bf',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '82c611c3-52f5-5bef-2f32-528ff50e55c0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '82c611c3-52f5-5bef-2f32-528ff50e55c1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '82c611c3-52f5-5bef-2f32-528ff50e55c2',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '82c611c3-52f5-5bef-2f32-528ff50e55c3',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: '82c611c3-52f5-5bef-2f32-528ff50e55c4',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '82c611c3-52f5-5bef-2f32-528ff50e55c5',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'f2b90660-7e0d-d342-7110-6801cbaad70f',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a66e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a66f',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a670',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a671',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a672',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a673',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a674',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a675',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a676',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a677',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'a0004589-e7b0-1e84-30b1-e8f35ed4a678',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8d6dbe57-4d44-822b-dfcf-3cbbd54779c6',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae89d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae89e',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae89f',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a2',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a3',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a4',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a5',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a6',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'be00ca5d-8c3d-c5a4-157c-ce5d527ae8a7',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'fa0a970c-6bd8-e11c-8933-2689cc2a9254',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('0838329a-f465-47c1-ac0d-f88b78a5e27f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8f205554-3bfc-c875-482e-0044fa9582f2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'a9a49247-2047-d486-ef14-8fa303fd504e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '8f205554-3bfc-c875-482e-0044fa9582f3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.placeholderImageMountains
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"6273206d496da5cc5f96d10b"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '653faa70-20af-ef13-c772-9eb7aba65c68'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                      EElement({
                                        id: '8f205554-3bfc-c875-482e-0044fa9582f4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '8a56d289-fea9-e830-23a1-39014ab6aacc'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '8f205554-3bfc-c875-482e-0044fa9582f5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '2a93c949-6cff-8ad4-c583-6ab893a4b71b'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8f205554-3bfc-c875-482e-0044fa9582f6',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Full Name'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '8f205554-3bfc-c875-482e-0044fa9582f7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '9446c9d0-4dcd-e8d3-d7dd-62c77070b880'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8f205554-3bfc-c875-482e-0044fa9582f8',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '8f205554-3bfc-c875-482e-0044fa9582f9',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                block: EText('inline'),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8829443b-f005-1554-a272-e89504531e07'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8f205554-3bfc-c875-482e-0044fa9582fa',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      children: EList([
                                                        EElement({
                                                          id: '8f205554-3bfc-c875-482e-0044fa9582fb',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'How we can help you'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '8f205554-3bfc-c875-482e-0044fa9582fc',
                                                    type: qualify(
                                                      Plugins.name('Embed'),
                                                      Component.name(
                                                        'HtmlEmbed'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      embed: ERecord({
                                                        type: EText('html'),
                                                        meta: ERecord({
                                                          html: EText(
                                                            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                          ),
                                                          div: EBoolean(false),
                                                          iframe:
                                                            EBoolean(false),
                                                          script:
                                                            EBoolean(false),
                                                          compilable:
                                                            EBoolean(false),
                                                        }),
                                                      }),
                                                      insideRTE:
                                                        EBoolean(false),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                                        ),
                                                      ]),
                                                      value: EText(
                                                        '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                                      ),
                                                      content: EDistinct({
                                                        name: qualify(
                                                          Plugins.name('Embed'),
                                                          typeName('CodeProp')
                                                        ),
                                                        value: EText(''),
                                                      }),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '521ef191-5e66-658e-6967-11c7bdbdab19',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('left'),
                        }),
                        styleBlockIds: EList([
                          EText('7b137dfc-5f2b-8ca2-183f-a864e1c415a4'),
                        ]),
                        children: EList([
                          EElement({
                            id: '521ef191-5e66-658e-6967-11c7bdbdab1a',
                            type: qualify(
                              Plugins.name('Icon'),
                              Component.name('Icon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                                icon: EText('slider-left'),
                              }),
                              children: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '521ef191-5e66-658e-6967-11c7bdbdab1b',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('right'),
                        }),
                        styleBlockIds: EList([
                          EText('7b137dfc-5f2b-8ca2-183f-a864e1c415a4'),
                        ]),
                        children: EList([
                          EElement({
                            id: '521ef191-5e66-658e-6967-11c7bdbdab1c',
                            type: qualify(
                              Plugins.name('Icon'),
                              Component.name('Icon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                                icon: EText('slider-right'),
                              }),
                              children: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '521ef191-5e66-658e-6967-11c7bdbdab1d',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderNav')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('nav'),
                        }),
                        styleBlockIds: EList([
                          EText('0c0f1761-2fc3-7afb-8e43-2958de381e0b'),
                        ]),
                        children: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '7a6a4223-2b09-a005-afa0-dd855e67cea8',
      type: 'class',
      name: 'Team Slider',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: 'e8e462ae-eca2-3d8e-55fa-0d15b916d1ba',
      type: 'class',
      name: 'Centered Subheading',
      comb: '',
      styleLess:
        'max-width: 530px; margin-right: auto; margin-left: auto; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: '9ed74efa-872c-7f3d-7ba4-cc728d8fed43',
      type: 'class',
      name: 'Team Slider Wrapper',
      comb: '',
      styleLess:
        'height: auto; margin-top: 50px; background-color: transparent;',
      children: [],
      variants: {},
    },
    {
      _id: '0838329a-f465-47c1-ac0d-f88b78a5e27f',
      type: 'class',
      name: 'Team Slide Wrapper',
      comb: '',
      styleLess: 'width: 30%; margin-right: 5%;',
      children: [],
      variants: {
        medium: {styleLess: 'width: 47%; margin-right: 6%;'},
        tiny: {styleLess: 'width: 100%; margin-right: 0%;'},
      },
    },
    {
      _id: 'a9a49247-2047-d486-ef14-8fa303fd504e',
      type: 'class',
      name: 'Team Block',
      comb: '',
      styleLess:
        'padding-bottom: 24px; background-color: hsla(0, 0.00%, 100.00%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '653faa70-20af-ef13-c772-9eb7aba65c68',
      type: 'class',
      name: 'Team Member Image Two',
      comb: '',
      styleLess: 'margin-bottom: 18px;',
      children: [],
      variants: {},
    },
    {
      _id: '8a56d289-fea9-e830-23a1-39014ab6aacc',
      type: 'class',
      name: 'Team Block Info',
      comb: '',
      styleLess:
        'display: flex; padding-right: 24px; padding-left: 24px; flex-direction: column; align-items: flex-start;',
      children: [],
      variants: {},
    },
    {
      _id: '2a93c949-6cff-8ad4-c583-6ab893a4b71b',
      type: 'class',
      name: 'Team Member Name Two',
      comb: '',
      styleLess: 'margin-bottom: 12px; font-weight: 600;',
      children: [],
      variants: {},
    },
    {
      _id: '9446c9d0-4dcd-e8d3-d7dd-62c77070b880',
      type: 'class',
      name: 'Team Member Text',
      comb: '',
      styleLess: 'margin-bottom: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: '8829443b-f005-1554-a272-e89504531e07',
      type: 'class',
      name: 'Text Link Arrow',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: center; color: #1a1b1f; font-size: 14px; line-height: 20px; text-decoration: none;',
      children: [],
      variants: {},
    },
    {
      _id: '6cdfed94-50ee-a092-b160-1f9b110b78cb',
      type: 'class',
      name: 'Arrow Embed',
      comb: '',
      styleLess: 'display: flex; margin-left: 2px;',
      children: [],
      variants: {},
    },
    {
      _id: '7b137dfc-5f2b-8ca2-183f-a864e1c415a4',
      type: 'class',
      name: 'Team Slider Arrow',
      comb: '',
      styleLess: 'display: none;',
      children: [],
      variants: {},
    },
    {
      _id: '0c0f1761-2fc3-7afb-8e43-2958de381e0b',
      type: 'class',
      name: 'Team Slider Nav',
      comb: '',
      styleLess:
        'position: static; bottom: -60px; margin-top: 24px; font-size: 10px;',
      children: [],
      variants: {},
    },
  ],
} as const;
